<template>
  <div class="stocks-table">
    <DataTable :data="dataTable" :columns="columns" :has-interaction="false" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { DataTable } from '@warrenbrasil/nebraska-web';

import { PortfolioSectionType } from '@/modules/wealth/services/portfolio';

import { formattedColumns, formattedDataTable } from './helpers';

interface Props {
  data: PortfolioSectionType;
}
const props = defineProps<Props>();

const columns = computed(() => {
  return formattedColumns(props.data);
});

const dataTable = computed(() => {
  return formattedDataTable(props.data);
});
</script>

<style lang="less" scoped>
.stocks-table {
  background-color: @background-secondary;
  border-radius: @size-radius-x200;
  padding: 0 @size-spacing-x400 @size-spacing-x300 @size-spacing-x400;

  ::v-deep th {
    white-space: nowrap;
  }
}
</style>
